module.exports = __webpack_public_path__ + "static/media/signIcon.db6f3c36.jpg";